import competenceConstants from '../constants';
import authConstants from 'areas/auth/constants';

export const initialState = {
    scheduledCompetenceDialogOpen: false,
    competenceChooserOpen: false,
    pendingListChosen: false,
    availableListChosen: true,
    activeCompetences: null,
    expiryDate: null,
    scanningPageOpen: false,
    manualLookupDialogOpen: false,
    qrDialogOpen: false,
    qrScannerDialogOpen: false,
};

export function competencies(state = initialState, action) {
    switch (action.type) {
        case authConstants.SIGN_OUT_SUCCESS:
            return initialState;

        case competenceConstants.OPEN_SCHEDULED_COMPETENCE_DIALOG:
            return {
                ...state,
                scheduledCompetenceDialogOpen: true
            };
        case competenceConstants.CLOSE_SCHEDULED_COMPETENCE_DIALOG:
            return {
                ...state,
                scheduledCompetenceDialogOpen: false
            };
        case competenceConstants.OPEN_COMPETENCE_SELECTION_SCREEN:
            return {
                ...state,
                competenceChooserOpen: true,
                pendingListChosen: action.showPendingList,
                availableListChosen: !action.showPendingList,
                activeCompetence: null,
                scanningPageOpen: false
            };
        case competenceConstants.CLOSE_COMPETENCE_SELECTION_SCREEN:
            return {
                ...state,
                competenceChooserOpen: false,
                scanningPageOpen: false
            };
        case competenceConstants.SELECT_PENDING_COMPETENCE_LIST:
            return {
                ...state,
                competenceChooserOpen: true,
                pendingListChosen: true,
                availableListChosen: false,
                scanningPageOpen: false
            };
        case competenceConstants.SELECT_AVAILABLE_COMPETENCE_LIST:
            return {
                ...state,
                competenceChooserOpen: true,
                pendingListChosen: false,
                availableListChosen: true,
                scanningPageOpen: false,

            };
        case competenceConstants.CHOOSE_COMPETENCE:
            return {
                ...state,
                activeCompetence: action.competence,
                expiryDate: action.expiryDate,
                competenceChooserOpen: false,
                scanningPageOpen: true
            };
        case competenceConstants.OPEN_SCANNING_PAGE:
            return {
                ...state,
                competenceChooserOpen: false,
                scanningPageOpen: true
            };
        case competenceConstants.CLOSE_SCANNING_PAGE:
            return {
                ...state,
                competenceChooserOpen: false,
                scanningPageOpen: false
            };
        case competenceConstants.OPEN_AUTH_CHOOSER:
            return {
                ...state,
                competenceChooserOpen: false,
                scanningPageOpen: true,
                manualLookupDialogOpen: false,
                qrDialogOpen: false
            };
        case competenceConstants.CLOSE_AUTH_CHOOSER:
        case competenceConstants.CLOSE_QR_DIALOG:
        case competenceConstants.CLOSE_MANUAL_LOOKUP_DIALOG:
            return {
                ...state,
                competenceChooserOpen: false,
                scanningPageOpen: true,
                manualLookupDialogOpen: false,
                qrDialogOpen: false,
                qrScannerDialogOpen: false
            };
        case competenceConstants.OPEN_QR_DIALOG:
            return {
                ...state,
                competenceChooserOpen: false,
                scanningPageOpen: true,
                manualLookupDialogOpen: false,
                qrDialogOpen: true,
                qrScannerDialogOpen: false
            };
        case competenceConstants.OPEN_QR_SCANNER_DIALOG:
            return {
                ...state,
                competenceChooserOpen: false,
                scanningPageOpen: true,
                manualLookupDialogOpen: false,
                qrDialogOpen: false,
                qrScannerDialogOpen: true
            };
        case competenceConstants.OPEN_MANUAL_LOOKUP_DIALOG:
            return {
                ...state,
                competenceChooserOpen: false,
                scanningPageOpen: true,
                manualLookupDialogOpen: true,
                qrDialogOpen: false
            };
        case competenceConstants.SELECT_COMPETENCE_AND_AWARD:
            return {
                scheduledCompetenceDialogOpen: false,
                competenceChooserOpen: false,
                pendingListChosen: true,
                availableListChosen: false,
                activeCompetence: action.competence,
                expiryDate: action.expiryDate,
                scanningPageOpen: true,
                manualLookupDialogOpen: false,
                qrDialogOpen: false,
            };
        default:
            return state;
    }
}
